(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["profile.domain.htm"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"cat-domain\">\r\n\t<div class=\"icn-domaine-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "slug"), env.opts.autoescape);
output += " domain-icon\"></div>\r\n\t<span>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "nom"), env.opts.autoescape);
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"lang") == "fr") {
output += " ";
;
}
output += ": ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "prc"), env.opts.autoescape);
output += "%</span>\r\n</div>\r\n\r\n<div class=\"button-flat button-flat-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += " button-pulse-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\" data-next data-domain-id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\">\r\n\t<span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"profile")),"domain")),"explore_families"), env.opts.autoescape);
output += "</span>\r\n</div>\r\n\r\n<div class=\"domain-details\">\r\n\t<h4>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"profile")),"domain")),"what_is"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "nom"), env.opts.autoescape);
output += " ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"profile")),"domain")),"what_is_suffix")) {
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"profile")),"domain")),"what_is_suffix"), env.opts.autoescape);
;
}
output += "?</h4>\r\n\t<p>\r\n\t\t";
output += runtime.suppressValue(env.getFilter("replace").call(context, env.getFilter("replace").call(context, env.getFilter("replace").call(context, env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "description")),"\r\n","<br/>"),"\n","<br/>"),"\r","<br/>"), env.opts.autoescape);
output += "\r\n\t</p>\r\n\r\n\t<h4>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"profile")),"domain")),"linked_families"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "nom"), env.opts.autoescape);
output += " ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"profile")),"domain")),"linked_families_suffix")) {
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "lng")),"profile")),"domain")),"linked_families_suffix"), env.opts.autoescape);
;
}
output += ":</h4>\r\n\t<ul>\r\n\t\t";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "familles");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("famille", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\r\n\t\t\t<li>";
output += runtime.suppressValue(runtime.memberLookup((t_4),"nom"), env.opts.autoescape);
output += "</li>\r\n\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t</ul>\r\n</div>\r\n\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
